import React from "react";
import { useLocation } from "react-router-dom";
import AppUtils from "@src/utils/appUtils";
import CrewUpdateForm from "@src/components/forms/CrewUpdateForm";
import { signolImagesRepositoryURL } from "@src/constants/constants";
import { ImageWithRetry } from "../../components/atoms";
import { authEndpoints, sharedEndpoints } from "@src/services/endpoints";
const CrewUpdatePage = () => {
  const { search } = useLocation();
  const [loading, setLoading] = React.useState(true);
  const [tokenData, setTokenData] = React.useState(null);
  const [submitted, setSubmitted] = React.useState(false);

  React.useEffect(() => {
    const query = new URLSearchParams(search);
    const token = query.get("t");

    if (token) {
      try {
        const payload = token.replace("SG-", ".").split(".")[1];
        const decoded = AppUtils.base64decode(payload);
        let params;
        try {
          params = JSON.parse(decoded);
        } catch {
          // Sendgrid tokens use JS object literal format (single-quoted values, unquoted keys)
          const asJson = decoded
            .replace(/([{,]\s*)([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g, '$1"$2":')
            .replace(/:\s*'([^']*)'/g, ':"$1"');
          params = JSON.parse(asJson);
        }
        if (params.operatorCodeLabel) {
          params.operatorCodeLabel = JSON.parse(params.operatorCodeLabel);
        }
        setTokenData(params);
      } catch (e) {
        console.error(e);
      }
    }

    setLoading(false);
  }, [search]);

  const handleNotifySignol = async (formData) => {
    if (tokenData?.imo) {
      const [result] = await Promise.allSettled([
        authEndpoints.crewUpdateInternal({
          firstname: formData.firstname,
          lastname: formData.lastname,
          role: formData.role,
          employeeId: formData.employeeId,
          joinedVesselOn: formData.joinedVesselOn,
          vesselImo: tokenData.imo,
        }),
      ]);
      if (result.status === "rejected" || result.value?.statusCode >= 400) {
        await sharedEndpoints.trackActivity({
          type: "OTHER",
          name: "CREW_UPDATE",
          username: formData.employeeId,
          scope: `UNKNOWN:CAPTAIN`,
          data: {
            timestamp: new Date().getTime(),
            attr: {
              firstname: formData.firstname,
              lastname: formData.lastname,
              role: formData.role,
              employeeId: formData.employeeId,
              joinedVesselOn: formData.joinedVesselOn,
              vesselName: tokenData.currentVesselName,
              imo: tokenData.imo,
            },
          },
        });
      }
    } else {
      await sharedEndpoints.trackActivity({
        type: "OTHER",
        name: "CREW_UPDATE",
        username: formData.employeeId,
        scope: `UNKNOWN:CAPTAIN`,
        data: {
          timestamp: new Date().getTime(),
          attr: {
            firstname: formData.firstname,
            lastname: formData.lastname,
            role: formData.role,
            employeeId: formData.employeeId,
            joinedVesselOn: formData.joinedVesselOn,
            vesselName: formData.currentVesselName,
            imo: formData.vesselImo,
          },
        },
      });
    }
    setSubmitted(true);
  };

  return (
    <div className="bg-white m-auto w-auto rounded-2xl max-w-[800px] shadow-md overflow-clip">
      {submitted ? (
        <>
          <div className="pt-3 mx-auto text-2xl md:text-3xl font-bold text-success text-success-500 text-center leading-snug">
            Thank you.
          </div>
          <div className="p-6">
            <div className="text-black text-center">
              Signol has been notified. You will soon receive your personalised
              welcome email introducing Signol in more detail.
            </div>
          </div>
        </>
      ) : (
        !loading && (
          <>
            <CrewUpdateForm
              onNotifySignol={handleNotifySignol}
              vesselName={tokenData?.currentVesselName}
              imo={tokenData?.imo}
              employeeIdSettings={tokenData?.operatorCodeLabel}
            />
            <div className="flex justify-between bg-primary-300 text-white">
              <div className="hidden md:flex mx-8 items-center justify-center">
                <ImageWithRetry
                  src={`${signolImagesRepositoryURL}/SignolLogoWhite.png`}
                  alt="Signol logo"
                  width="60"
                />
              </div>
              <div className="flex flex-1 justify-end gap-2">
                <a
                  href="mailto:support@signol.io?Subject=Support"
                  className="my-4 mx-8 font-bold underline cursor-pointer"
                >
                  Support
                </a>
              </div>
            </div>
          </>
        )
      )}
    </div>
  );
};

export default CrewUpdatePage;
